










import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  watch,
} from '@vue/composition-api';
import switchOrg from '@/renderer/components/user/components/switchOrg.vue';
import TeamPay from '@/renderer/components/teamPay/index.vue';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
// 引入工具类
import { openTeamPayDialog, PAY_SOURCE, closeDialog } from '@/renderer/scripts/composition/dialogHandler';
import user from '@/renderer/scripts/utils/user';
export default defineComponent({
  components: {
    switchOrg,
    TeamPay,
  },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const showSwitchOrg = ref(false);
    const showTeamPay = computed(() => vm.$store.getters.teamPay.show);
    let timer: number | undefined = undefined;
    const showDialog = () => {
      const { editionFlag, orgExpired } = store.getters;
      if (orgExpired && editionFlag !== 'personal') {
        openTeamPayDialog(PAY_SOURCE.ORG_EXPIRED);
      }
    };

    // 定时器判断是否已经续费,已经续费跳转至工作台
    const refreshExpired = () => {
      timer = window.setInterval(() => {
        const nowTime = new Date().getTime();
        store.dispatch('GetOrgInfo', store.getters.orgId);
        const { expireTime } = store.getters;
        if (new Date(expireTime).getTime() > nowTime) {
          user.setOrgExpired(false);
          dispatchRouter(
            {
              name: 'workbench',
            },
            'replace',
          );
        }
      }, 3 * 1000);
    };
    onMounted(() => {
      showDialog();
      refreshExpired();
    });
    onUnmounted(() => {
      closeDialog();
      window.clearInterval(timer);
      timer = undefined;
    });
    watch(
      () => store.getters.showOrgList,
      val => {
        if (val) {
          showSwitchOrg.value = val;
        }
      },
      {
        immediate: true,
      },
    );
    watch(
      showSwitchOrg,
      val => {
        !val && store.commit('setShowOrgList', false);
      },
      {
        immediate: true,
      },
    );
    return {
      showSwitchOrg,
      showTeamPay,
    };
  },
});
